import React, { useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { GET_CURRENT_REQUEST } from 'components/dashboard/Auth/constant';
import { isTokenExpired } from 'utils/token';
const PrivateRoute = ({ component: Component, ...rest }) => {
  const fakeAuth = useSelector(state => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: GET_CURRENT_REQUEST,
    });
  }, [dispatch]);

  const token = sessionStorage.getItem('token');
  const isValid = fakeAuth.isLogin || (token && !isTokenExpired(token));

  return (
    <Route
      {...rest}
      render={props =>
        isValid ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/', state: { from: props.location } }} />
        )
      }
    />
  );
};

export default PrivateRoute;
